<input class="form-control input-number__input" type="number"
       [ngClass]="{'form-control-sm': size === 'sm', 'form-control-lg': size === 'lg'}"
       [min]="options.min"
       [max]="options.max"
       [value]="value"
       [disabled]="options.disabled"
       [readOnly]="options.step != 1 || changeByClickOnly"
       (input)="input()"
       (blur)="onTouched()" #inputElement>

<div [ngClass]="{'disabled': isAddDisabled(inputElement.value)}" class="input-number__add" (mousedown)="add()"></div>
<div [ngClass]="{'disabled': inputElement.value <= options.min && canSubBeDisabled}" class="input-number__sub" (mousedown)="sub()"></div>